import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle, faSave } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "@mui/material";
import { ProductStore } from "../ProductStore";

export default function CatalogSelector( { 
    catalogType, 
    catalogItems, 
    showAddState, 
    productFieldName, 
    placeholder, 
    label, 
    onCreateNewValue,
    onCancelNewValue,
    onHandleChangeOfNewValue,
    onPressedEnterKey,
    tempValue,
    product,
    onProductChange
} ) {
    const showAdd = ProductStore.useState( state => state[showAddState] );

    return (
        <div className="row mb-2">
            <div className="col-md-3 fw-bold d-flex align-items-center justify-content-between">
                {label}
                <Tooltip title={`Agregar nueva ${label.toLowerCase()}`}>
                    <button
                        onClick={() => ProductStore.update( s => {
                            s[showAddState] = true;
                        } )}
                        className="btn-sm btn text-primary">
                        <FontAwesomeIcon icon={faPlusCircle} className="ml-2"/>
                    </button>
                </Tooltip>
            </div>
            <div className="col-md-9">
                {
                    showAdd ?
                        <div className="p-2">
                            <input
                                onChange={onHandleChangeOfNewValue}
                                value={tempValue}
                                minLength={4}
                                maxLength={20}
                                autoFocus
                                onKeyUp={( e ) => onPressedEnterKey( e, catalogType )}
                                placeholder={placeholder}
                                type="text"
                                className="form-control"
                            />
                            <div className="d-flex justify-content-end mt-2">
                                <button onClick={onCancelNewValue}
                                    className="btn btn-sm">Cancel
                                </button>
                                <button onClick={() => onCreateNewValue( catalogType )}
                                    className="btn btn-sm btn-success">
                                    <FontAwesomeIcon icon={faSave}/> Save
                                </button>
                            </div>
                        </div>
                        :
                        <select 
                            value={product[productFieldName]} 
                            onChange={onProductChange}
                            className="form-control" 
                            name={productFieldName}>
                            <option value={0}> --</option>
                            {
                                catalogItems.length > 0 && catalogItems.map( ( c, i ) => {
                                    return <option key={i} value={c.id}>{c.value}</option>;
                                } )
                            }
                        </select>
                }
            </div>
        </div>
    );
}
